import { ReactElement } from 'react';
import { Typography, TypographyProps } from '@mui/material';

import { ShareIcon } from 'modules/common/icons';
import { cropString } from 'modules/common/utils/cropString';
import { getTransactionDetailsLink } from 'modules/common/utils/getTransactionDetailsLink';

interface ITxLinkProps extends TypographyProps {
  txHash: string;
}

export function TxLink({ txHash }: ITxLinkProps): ReactElement {
  return (
    <Typography
      component="a"
      href={getTransactionDetailsLink(txHash)}
      rel="noreferrer"
      sx={theme => ({
        color: theme.palette.text.primary,
        fontWeight: 600,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
      })}
      target="_blank"
      variant="body1"
    >
      <span>{cropString(txHash)}</span>

      <ShareIcon />
    </Typography>
  );
}
